import { Observable } from "rxjs/Observable"

export interface IDropdownField {
      lable?: string,
      placeholder?: string,
      selectValue?: any,
      formControlName?: string,
      isRequired?: boolean,
      isServerError?: boolean,
      serverErrorText?: string,
      isReadOnly?: boolean,
      isMultipleSelect?: boolean,
      isSearch?: boolean,
      dropdownList: any[],
      isValueBind?: boolean, // on select emit value and also bind with value
      isFullObject?: boolean, // on select emit full item
      dataField?: string,
      isYearDropdown?: any
}
export interface IList {
      name: string,
      value: any
}
export class YearPickerDataModel {
      name: string | number | null = null;
      startYear: string | number | null = null;
      endYear: string | number | null = null;
}
export class YearDetailsModel {
      yearFrom: number | null = null;
      yearTo: number | null = null;
      isShowFromToYear: boolean = null;
} 